module.exports = __webpack_public_path__ + "d664201f/img/trash-icon.ff8201c7.svg";